module.exports = __webpack_public_path__ + "static/media/gpay.c785d32e.svg";